import type { GaMappingParams, GoogleAnalyticsPayload, GoogleAnalyticsValue } from "./types";

const sanitizeGoogleAnalytics = (payload: GoogleAnalyticsPayload): Record<string, GoogleAnalyticsValue> => {
	const clean: Record<string, GoogleAnalyticsValue> = {};

	for (const [key, value] of Object.entries(payload)) {
		if (value !== undefined && value !== null && value !== "" && value !== "NA") {
			clean[key] = value;
		}
	}

	return clean;
};

export const mapCleverTapToGA = (params: GaMappingParams): Record<string, GoogleAnalyticsValue> => {
	const { ctPayload, dataLayer, destinationUrl, position, gaEventType, overrides } = params;

	const payload: GoogleAnalyticsPayload = {
		component_name: dataLayer.component,
		event: gaEventType,
		destination_url: destinationUrl ?? dataLayer.destination_url,
		page_path: ctPayload.EP_PAGE_NAME,
		page_url: dataLayer.page_url ?? ctPayload.EP_PAGE_URL,
		utm_source: ctPayload.EP_UTM_SOURCE,
		utm_medium: ctPayload.EP_UTM_MEDIUM,
		utm_campaign: ctPayload.EP_UTM_CAMPAIGN,
		utm_content: ctPayload.EP_UTM_CONTENT,
		product_name: dataLayer.product_name,
		product_category: dataLayer.product_category,
		page_type: dataLayer.page_type,
		section_title: dataLayer.section_title,
		sub_section: dataLayer.sub_section,
		element: dataLayer.element,
		cta_text: dataLayer.cta_text,
		entry_point: dataLayer.entry_point,
		form_name: dataLayer.form_name,
		field_name: dataLayer.field_name,
		field_value: dataLayer.field_value,
		submission_status: dataLayer.submission_status,
		time_spent: dataLayer.time_spent,
		application_id: dataLayer.application_id,
		journey_tag: dataLayer.journey_tag,
		stage_tag: dataLayer.stage_tag,
		validation_error: dataLayer.validation_error,
		tab_position: dataLayer.tab_position,
		position: position ?? dataLayer.tab_position,
		unique_asset_id: dataLayer.unique_asset_id,
		input_amount: dataLayer.custom_attr1 ?? dataLayer.input_amount,
		offer_amount: dataLayer.offer_amount,
		component_id: dataLayer.component_id,
		nudge_type: dataLayer.nudge_type,
		nudge_value: dataLayer.nudge_value,
		component_position: dataLayer.component_position,
		segment_name: dataLayer.segment_name,
		sprint_release: dataLayer.sprint_release,
		loan_variant: dataLayer.loan_variant,
		loan_range: dataLayer.loan_range,
		amount_ai: dataLayer.amount_ai,
		tenure: dataLayer.tenure,
		tenure_ai: dataLayer.tenure_ai,
		current_rate_of_interest: dataLayer.roi,
		roi_ai: dataLayer.roi_ai,
		monthly_instalment: dataLayer.monthly_instalment,
		pwa_version: dataLayer.pwa_version,
		customer_tag: dataLayer.customer_tag,
		customer_id: dataLayer.customer_id,
		platform: ctPayload.EP_PLATFORM,
		language: ctPayload.EP_LANG,
		is_loggedin: dataLayer.is_loggedin,
		tag2: dataLayer.custom_attr2,
		tag3: dataLayer.custom_attr3,
	};

	return sanitizeGoogleAnalytics({ ...payload, ...(overrides ?? ({} as GoogleAnalyticsPayload)) });
};
